import { useContext, useState } from 'react';
import { CloudDownloadIcon, Edit05Icon } from 'assets/icons';
import { Button, ButtonStyle } from 'common/button';
import { DownloadVaultModal } from 'common/download-vault-modal';
import { ModalEditVault } from 'common/modal-edit-vault';
import cardStyles from 'common/settings-layout/settings-card.module.scss';
import { VaultAvatar } from 'common/vault-avatar';
import { AppContext } from 'context';
import { classnames, hasVaultAccess } from 'helpers/utils';
import { Vault } from 'models/vault';
import styles from './vault-section.module.scss';

type VaultSectionProps = {
  vault: VaultType;
  isOwner: boolean;
  refetchVault: () => Promise<void>;
};

// The vault's name and cover photo, with the owner's way to change them (the
// same modal the albums header uses) and the offline copy of the whole vault.
const VaultSection = ({ vault, isOwner, refetchVault }: VaultSectionProps) => {
  const {
    state: {
      data: { user },
    },
  } = useContext(AppContext);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const cover = vault.coverThumbnailUrl || vault.coverUrl;

  return (
    <div className={classnames(cardStyles.card, styles.vaultSection)}>
      <div className={cardStyles.cardHeader}>
        <p className="text__title2__gray800">Vault Details</p>
        {isOwner && (
          <Button
            buttonStyle={ButtonStyle.TertiaryGray}
            className={cardStyles.editButton}
            aria-label="Edit name & cover photo"
            onClick={() => setShowEditModal(true)}
          >
            <Edit05Icon />
          </Button>
        )}
      </div>
      <div className={styles.row}>
        {cover ? (
          <img className={styles.cover} src={cover} alt="" />
        ) : (
          <VaultAvatar isSmall isLockedOrRestrictedVault={false} />
        )}
        <p className={classnames(styles.title, 'text__title2__gray800')}>
          {vault.title}
        </p>
      </div>
      {hasVaultAccess(user, vault) && (
        <Button
          buttonStyle={ButtonStyle.SecondaryGray}
          className={classnames(
            cardStyles.pillButton,
            cardStyles.pillMuted,
            styles.downloadButton,
          )}
          onClick={() => setShowDownloadModal(true)}
        >
          Download Vault
          <CloudDownloadIcon />
        </Button>
      )}
      {showEditModal && (
        <ModalEditVault
          vault={vault as Vault}
          onClose={() => setShowEditModal(false)}
          onSuccess={async () => {
            setShowEditModal(false);
            await refetchVault();
          }}
        />
      )}
      {showDownloadModal && (
        <DownloadVaultModal
          vault={vault}
          onClose={() => setShowDownloadModal(false)}
        />
      )}
    </div>
  );
};

export { VaultSection };
